<template>
  <swiper
    :modules="modules"
    effect="fade"
    :slides-per-view="1"
    :loop="true"
    :speed="600"
    :autoplay="{
      delay: 4000,
      disableOnInteraction: false,
    }"
    class="health-club-swiper"
  >
    <swiper-slide v-for="(slide, index) in slides" :key="index">
      <div class="slide">
        <picture class="slide-picture">
          <source media="(max-width: 767px)" :srcset="slide.img375" />
          <source media="(max-width: 1023px)" :srcset="slide.img768" />
          <source media="(max-width: 1279px)" :srcset="slide.img1024" />
          <source media="(max-width: 1439px)" :srcset="slide.img1280" />
          <source media="(max-width: 1919px)" :srcset="slide.img1440" />
          <img
            class="slide-image"
            :src="slide.img1920"
            :alt="$t('homeNew.healthClub.slides.' + index + '.line1')"
          />
        </picture>
        <div class="slide-text">
          <div class="slide-text-inner">
            <div class="slide-line1">{{ $t('homeNew.healthClub.slides.' + index + '.line1') }}</div>
            <div class="slide-line2">{{ $t('homeNew.healthClub.slides.' + index + '.line2') }}</div>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import health1_375 from '@/assets/img/main-health-club/health_1_375.jpg';
import health1_768 from '@/assets/img/main-health-club/health_1_768.jpg';
import health1_1024 from '@/assets/img/main-health-club/health_1_1024.jpg';
import health1_1280 from '@/assets/img/main-health-club/health_1_1280.jpg';
import health1_1440 from '@/assets/img/main-health-club/health_1_1440.jpg';
import health1_1920 from '@/assets/img/main-health-club/health_1_1920.jpg';

import health2_375 from '@/assets/img/main-health-club/health_2_375.jpg';
import health2_768 from '@/assets/img/main-health-club/health_2_768.jpg';
import health2_1024 from '@/assets/img/main-health-club/health_2_1024.jpg';
import health2_1280 from '@/assets/img/main-health-club/health_2_1280.jpg';
import health2_1440 from '@/assets/img/main-health-club/health_2_1440.jpg';
import health2_1920 from '@/assets/img/main-health-club/health_2_1920.jpg';

import health3_375 from '@/assets/img/main-health-club/health_3_375.jpg';
import health3_768 from '@/assets/img/main-health-club/health_3_768.jpg';
import health3_1024 from '@/assets/img/main-health-club/health_3_1024.jpg';
import health3_1280 from '@/assets/img/main-health-club/health_3_1280.jpg';
import health3_1440 from '@/assets/img/main-health-club/health_3_1440.jpg';
import health3_1920 from '@/assets/img/main-health-club/health_3_1920.jpg';

import { Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/effect-fade';

export default {
  name: 'MainHealthClubSlider',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, EffectFade],
    };
  },
  data() {
    return {
      slides: [
        {
          img375: health1_375,
          img768: health1_768,
          img1024: health1_1024,
          img1280: health1_1280,
          img1440: health1_1440,
          img1920: health1_1920,
        },
        {
          img375: health2_375,
          img768: health2_768,
          img1024: health2_1024,
          img1280: health2_1280,
          img1440: health2_1440,
          img1920: health2_1920,
        },
        {
          img375: health3_375,
          img768: health3_768,
          img1024: health3_1024,
          img1280: health3_1280,
          img1440: health3_1440,
          img1920: health3_1920,
        },
      ],
    };
  },
};
</script>

<style scoped>
.health-club-swiper {
  width: 100%;
  height: 140vw;
}

@media screen and (min-width: 580px) {
  .health-club-swiper {
    height: 120vw;
  }
}

@media screen and (min-width: 768px) {
  .health-club-swiper {
    height: 70vw;
  }
}

@media screen and (min-width: 1180px) {
  .health-club-swiper {
    height: calc(100vh - 192px);
  }
}

.slide {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.slide-text {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 40px 16px 0;
  color: white;
  text-align: left;
  box-sizing: border-box;
}

.slide-text-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .slide-text {
    width: 50%;
    justify-content: center;
    padding: 0 40px;
  }

  .slide-text-inner {
    max-width: 600px;
  }
}

@media screen and (min-width: 1024px) {
  .slide-text-inner {
    gap: 20px;
  }
}

@media screen and (min-width: 1440px) {
  .slide-text {
    padding: 0 80px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-text {
    padding: 0 120px;
  }

  .slide-text-inner {
    max-width: 720px;
  }
}

.slide-line1 {
  white-space: pre-line;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 36px;
}

.slide-line2 {
  white-space: pre-line;
  line-height: 1.2;
  font-weight: 400;
  font-size: 20px;
}

@media screen and (min-width: 1024px) {
  .slide-line1 {
    font-size: 40px;
  }

  .slide-line2 {
    font-size: 22px;
  }
}

@media screen and (min-width: 1440px) {
  .slide-line1 {
    font-size: 48px;
  }

  .slide-line2 {
    font-size: 24px;
  }
}

@media screen and (min-width: 1920px) {
  .slide-line1 {
    font-size: 54px;
  }

  .slide-line2 {
    font-size: 26px;
  }
}
</style>
